<template>
  <v-layout justify-center>
    <v-dialog transition="dialog-bottom-transition" persistent
        v-model="get_dialogMain.dialog" scrollable  :max-width="get_dialogMain.withWindows">
        <v-card width="auto" tile>
            <v-toolbar dense dark color="blue darken-2">
                <v-toolbar-title> <h3 class="ma-1">{{ get_dialogMain.title }}</h3></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="HIDDE_DIALOG_MAIN()"> <v-icon>mdi-close</v-icon> </v-btn>
            </v-toolbar>
            <v-card-text class="pa-4">
                <FormsMainGral v-if="form"
                    titleButton="Crear"
                    :formCreate="form"
                    :on-success="success"
                    :on-cancel="cancel"
                    :model="object" />
            </v-card-text>
        </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import FormsMainGral from '@/components/forms/formsMainGral'
import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  name: 'dialogGral',
  props: ['form', 'model', 'action'],
  data: () => ({
    object: {}
  }),
  components: {
    FormsMainGral
  },
  mounted () {},
  methods: {
    ...mapActions(['getUrlServices', 'urlPostServicesAction']),
    success (model) {
      const router = this.get_urls[this.action]
      this.urlPostServicesAction({ url: router, data: model })
    },
    cancel () {
      this.HIDDE_DIALOG_MAIN()
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'SET_DATA_OBJECT'])
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_object'])
  },
  watch: {
    get_object (val) {
      if (val.code !== 200) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitos!',
        text: val.message
      })
      this.SET_DATA_OBJECT(val.data)
      this.cancel()
    }
  }
}
</script>

<style>
</style>
